/**
 * Styled Components - Created by david on 12/02/18.
 */
import styled from 'styled-components'
import Carousel from 'antd/lib/carousel'
import {
  WHITE,
  BLACK_LABEL,
  GRAY_BG,
  BLUE_LIGHT,
  GRAY_DARK,
  BLUE,
  GRAY_SKELETON,
  GRAY
} from '../../theme/colors'
import Icon from 'antd/lib/icon'
import Skeleton from 'antd/lib/skeleton'

export const Container = styled.div``

export const Text = styled.div`
  color: ${WHITE};
`

interface HeaderProps {
  hideTopHeader?: boolean
  hideBottomHeader?: boolean
  backgroundColor?: string
  loading?: boolean
}

interface DivProps {
  secondary?: boolean
  loading?: boolean
  showBar?: boolean
  openSizeRec?: boolean
}

export const Header = styled.div`
  background: ${WHITE};
  line-height: 0px;
  padding: 0px;
  z-index: 10;
  display: ${({ loading }: HeaderProps) => !loading ? 'auto' : 'none'};
  -webkit-transform: translate3d(0, 0, 0);
  animation: fade-in-topBar 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @media (min-width: 1100px) {
    position: sticky;
    top: 0;
    z-index: 94;
  }
  @keyframes fade-in-topBar {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  ${({ openSizeRec }: DivProps) => openSizeRec ? `
    @media (max-width: 698px) {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1000;
    }
  ` : ''}
`

export const Footer = styled.footer`
  font: 400 14px/22px var(--font-inter);
  padding: var(--spacing-100) var(--spacing-72, 72px) var(--spacing-64) var(--spacing-72, 72px);
  background: var(--neutral-darkest);

  @media (max-width: 1024px) {
    padding: 16px;
  }

  @media (max-width: 698px) {
    font-size: 12px;
    padding: var(--spacing-48) var(--spacing-24);
  }
`

export const CarouselContainer = styled.div`
  position: relative;
  ${({ secondary }: DivProps) => secondary ? `
    z-index: 4;
    position: fixed;
  ` : ''}
`

export const CloseIcon = styled(Icon)`
  margin-top: -46px;
  display: flex;
  z-index: 990;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  font-size: 12px;
  right: 12px;
  border: 1px solid ${BLACK_LABEL};
  color: ${BLACK_LABEL};
  border-radius: 25px;
  transition: .25s;
  background: #eaeaea;
  &:hover {
    cursor: pointer;
    background: ${BLACK_LABEL};
    color: #fdb532;
  }
`

export const StyledCarousel = styled(Carousel)`
  background-color: #fdb532;
  .slick-dots {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    height: 100%;
    top: 0;
    right: 16px;
    width: auto;
    @media (max-width: 768px) {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      height: unset;
      top: unset;
      right: unset;
      width: 100%;
    }
  }
  .slick-dots li button {
    height: 0;
  }
  .slick-dots li button:before {
    background: none;
    border-radius: 100px;
    border: 1px solid black;
    content: '';
    height: 12px;
    width: 12px;
    opacity: 1;
    margin-top: 4px;
  }
  .slick-dots li.slick-active button:before {
    background: black;
    opacity: 1;
  }
  @media (max-width: 768px) {
    background-color: ${WHITE};
  }
`

export const EditorWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ backgroundColor }: HeaderProps) => backgroundColor || '#fdb532'};
  height: auto;

  .rdw-editor-wrapper {
    flex: 1;
  }
  .rdw-editor-main {
    display: flex;
    justify-content: center;
  }
  span {
    background-color: transparent !important;
    font-size: 14px !important;
  }
  @media (max-width: 768px) {
    padding: 0 13px;
    margin-bottom: ${({ secondary }: DivProps) => secondary ? '0px' : '28px'};
    box-shadow: ${({ backgroundColor }: HeaderProps) => backgroundColor ? `0 0 4px 1px ${backgroundColor}` : 'unset'};
  }
`

export const BehalfDiv = styled.div`
  position: fixed;
  bottom: -2px;
  left: calc(50vw - 126px);
  z-index: 99999;
  display: flex;
  background: #bd3348;
  padding: 10px 24px;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  color: ${WHITE};
  font-size: 12px;
  align-items: center;
  box-shadow: 0px -1px 5px -1px #767676;
`

export const BehalfText = styled.div`
  font-family: Avenir;
  display: flex;
  color: ${WHITE};
  padding-right: 12px;
  border-right: 1px solid #d16767;
`

export const UserIcon = styled(Icon)`
  margin-right: 10px;
  margin-bottom: 2px;
`

export const UserDiv = styled.div`
  margin-left: 6px;
  font-family: Avenir;
  font-weight: bold;
`

export const LogoutIcon = styled(Icon)`
  margin-left: 12px;
  color: ${WHITE};
  margin-bottom: 2px;
  font-size: 13px;
  transition: all .25s;
  filter: drop-shadow(0px 0px 2px #494949);
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const TopBar = styled.div`
  width: 100%;
  min-height: 58px;
  display: flex;
  background: ${WHITE};
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 5px -1px #585858;
  z-index: 2;
  display: ${({ loading }: DivProps) => !loading ? 'flex' : 'none'};
  animation: fade-in-top 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.2s both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const LogoIcon = styled.img`
  max-width: 130px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const WelcomeTitle = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  font-size: 22px;
`

export const WelcomeBody = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 698px) {
    width: calc(100% + 24px);
    margin-left: -12px;
  }
`

export const SubtitleWelcome = styled.div`
  margin-top: 10px;
  margin-bottom: 14px;
  text-align: center;
`

export const MarketingTitle = styled.div`
  font-family: Avenir;
  font-weight: bold;
  font-size: 16px;
`

export const MarketingOptions = styled.div`
  margin-top: 16px;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 12px;
`

export const MarketingOption = styled.div`
  border-radius: 25px;
  height: fit-content;
  padding: 8px 10px;
  display: inline-block;
  font-size: 11px;
  font-weight: normal;
  margin-right: 12px;
  margin-bottom: 14px;
  font-weight: 500;
  font-family: Avenir-Medium;
  border: 1px solid ${({ secondary }: DivProps) => secondary ? BLUE_LIGHT : GRAY_BG};
  transition: all .25s;
  box-shadow: 1px 2px 3px -1px #e5e5e5;
  color: ${({ secondary }: DivProps) => secondary ? BLUE_LIGHT : GRAY_DARK};
  &:hover {
    cursor: pointer;
    border: 1px solid ${BLUE_LIGHT};
  }
  &:last-child {
    margin-right: 0px;
  }
  animation: blink-1 0.9s 2 0.5s ease-in-out;
  @keyframes blink-1 {
    0% {
      background: ${WHITE};
    }
    50% {
      background: #c0edfe;
    }
    100% {
      background: ${WHITE};
    }
  }
`

export const SubmitButton = styled.div`
  background: ${({ secondary }: DivProps) => secondary ? GRAY_SKELETON : BLUE};
  padding: 8px 22px;
  border-radius: 5px;
  color: ${({ secondary }: DivProps) => secondary ? GRAY : WHITE};
  box-shadow: 1px 2px 3px -1px #969696;
  margin-bottom: 16px;
  transition: all .25s;
  ${({ secondary }: DivProps) => !secondary ? `
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  ` : ''}
`

export const CancelButton = styled.div`
  color: #909090;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    text-decoration: underline;
  }
`

export const CircleEmpty = styled.div`
  width: 14px;
  height: 14px;
  display: inline-block;
  border: 1px solid #dddddd;
  vertical-align: middle;
  border-radius: 25px;
  margin-right: 7px;
  margin-bottom: 1px;
  padding-left: 8px;
`

export const CircleIcon = styled(Icon)`
  margin-right: 8px;
  color: ${BLUE_LIGHT};
  font-size: 14px;
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 1px;
`

export const SkeletonBar = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 5px -3px lightgrey;
  z-index: 2;
  padding-top: 12px;
  background: white;
  margin-bottom: -8px;
  height: 108px;
  position: relative;
`

export const IconSkeleton = styled(Skeleton)`
  margin-left: 40px;
  margin-right: 40px;
  width: fit-content;
  padding: 0;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-header {
    padding-right: 0;
  }
  .ant-skeleton-avatar {
    width: 50px;
    height: 50px;
    border-radius: 7px;
  }
`

export const TopSkeleton = styled(Skeleton)`
  position: absolute;
  top: 4px;
  right: 30px;
  max-width: 304px;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-title {
    border-radius: 5px;
    height: 12px;
  }
`

export const NavSkeleton = styled(Skeleton)`
  margin-right: 50px;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-title {
    border-radius: 3px;
  }
`

export const SearchSkeleton = styled(Skeleton)`
  margin-right: 30px;
  max-width: 188px;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-title {
    border-radius: 25px;
    height: 20px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MainLayout/styledComponents.tsx